export default __webpack_public_path__ + "static/media/up-arrow.953c2084.svg";